import React from 'react'
import PageLayout from 'components/PageLayout'
import Seo from 'components/Seo'
import Header from 'components/newHeader'
import ContactFormSection from 'components/sections/ContactFormSection'

const ContactPage = () => (
  <PageLayout hideFooter>
    <Seo title="Contact Us" />
    <Header />
    <ContactFormSection />
  </PageLayout>
)

export default ContactPage
